// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const jsSHA = require('jssha')
class GuestUser {
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'authenticated' does not exist on type 'G... Remove this comment to see the full error message
      this.prototype.authenticated = false
   }
}
GuestUser.initClass()

class FlowUser {
   email: any
   name: any
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'authenticated' does not exist on type 'F... Remove this comment to see the full error message
      this.prototype.authenticated = true
   }
   constructor(attrs: any) {
      this.name  = attrs.name
      this.email = attrs.email
   }
}
FlowUser.initClass()

class FlowService {
   $http: any
   $q: any
   auth: any
   bucket: any
   configs: any
   fire: any
   items: any
   savedItems: any
   translationService: any
   constructor($http: any, $q: any, config: any, store: any, translationService: any, savedItems: any, hooksService: any) {
      this.getProfile = this.getProfile.bind(this)
      this.signOff = this.signOff.bind(this)
      this.getCallbackUrl = this.getCallbackUrl.bind(this)
      this.save = this.save.bind(this)
      this.contains = this.contains.bind(this)
      this.getCallBackUrlFor = this.getCallBackUrlFor.bind(this)
      this.setAuthenticated = this.setAuthenticated.bind(this)
      this.setGuest = this.setGuest.bind(this)
      this.$http = $http
      this.$q = $q
      this.translationService = translationService
      this.savedItems = savedItems
      this.configs = angular.copy(config.data.flow)
      this.configs.banner = {
         enabled: this.configs.enabled,
         signupText: this.translationService.translations.SIGN_UP_FREE
      }

      this.configs.loginText = this.translationService.translations.REFWORKS_LOG_IN
      this.configs.logoutText = this.translationService.translations.LOG_OUT

      this.auth =
      {user: undefined}

      hooksService.setHooks(this, 'FlowService', ['authChange', 'itemSaveCompletion'])

      this.bucket = store.bucket('flowItems')
      if (this.bucket.age() > (20*60)) { this.bucket.clear() } // 20 minutes
      this.items = this.bucket.get('items') || []
   }

   getProfile() {
      const deferred = this.$q.defer()
      deferred.promise.then((data: any) => {
         return this.setAuthenticated(data)
      }
      , () => {
         return this.setGuest()
      })

      const xhr = this.$http.get('/flow/profile')
      xhr.then(function(response: any) {
         const {
            data
         } = response
         if (data.error != null) { // -> error
            return deferred.reject('auth error')
         } else {
            return deferred.resolve(data)
         }
      }
      , () => deferred.reject('server error'))
      return deferred
   }

   signOff() {
      this.bucket.clear()
      return this.setGuest()
   }

   getCallbackUrl() {
      const pre = this.getCurrentUrlPrefix()
      const current = this.getCurrentUrl()
      const e = encodeURIComponent
      return `${pre}/flow/auth/${e(e(current))}/`
   }

   getAuthParams() {
      const promise = this.$http.get("/flow/signature")
      return promise.then((response: any) => {
         const timeStamp = response.data.timeStamp
         const signature = response.data.signature
         return [timeStamp, signature]
      })
   }

   save(documents = []) {
      // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type 'never'.
      const ids = documents.map(doc => doc.id)
      const requestData =
      {ids: ids.join(',')}

      const broadcastCompletion = (data: any) => {
         return this.fire('itemSaveCompletion', data)
      }

      const promise = this.$http.post("/flow/save", requestData)
      promise.then((response: any) => {
         _.each(ids, (id: any) => {
            if (!_.contains(this.items, id)) { return this.items.push(id) }
         })
         this.bucket.set('items', this.items)
         // clear out temp saved items folder on successful save to flow
         if (this.savedItems.items.length) { this.savedItems.clear() }
         return broadcastCompletion(response.data)
      }
      , function(response: any) {
         const msg = {
            errorMessage: response.data.error,
            ids: requestData.ids.split(',')
         }
         return broadcastCompletion(msg)
      })
      return promise
   }

   contains(item: any) {
      if (!item) { return false }
      // TODO: optimize with lookup table (by id) if this gets too slow
      return _(this.items).some((id: any) => item.id === id)
   }

   // private!

   getCurrentUrl() {
      const pre  = this.getCurrentUrlPrefix()
      const post = location.hash.substring(2)
      return pre + post
   }

   getCurrentUrlPrefix() {
      const {
         href
      } = location
      return href.substring(0, href.indexOf('/', 8))
   }

   getCallBackUrlFor() {
      const pre = this.getCurrentUrlPrefix()
      const current = this.getCurrentUrl()
      const e = encodeURIComponent
      return `${pre}/flow/auth/${e(e(current))}/`
   }

   setAuthenticated(data: any) {
      this.auth.user = new FlowUser({name: data.name, email: data.email})
      if (this.savedItems.items.length) {
         this.save(this.savedItems.items)
      }
      return this.fire('authChange')
   }

   setGuest() {
      this.auth.user = new GuestUser
      this.items.length = 0
      return this.fire('authChange')
   }
}


FlowService.$inject = ['$http', '$q', 'configService', 'storeService', 'translationService', 'savedItemsService', 'hooksService']


angular.module('summonApp.services')
   .service('flowService', FlowService)
